import React , {Component} from 'react';
import axios from 'axios';
// import '../../css/normalize.css'
// import '../../css/grid.css'
// import '../../css/grid.css'
import './Home.css'
import { Route, Link } from "react-router-dom";
import { Map, Marker, Popup, TileLayer, GeoJSON } from 'react-leaflet'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

toast.configure()

class Home  extends Component {

  constructor(props) {
    super(props);
  }

    state = {
      oatrc : {},
      skq : {},
      ark : {},

      endpoint:'https://vims.cis.udel.edu/geography/seaice/services/'
    }


  getSpatialCoverage = (ship_name) => {
      let url = this.state.endpoint + 'spatialcoverage/'
      + "ship_name=" + ship_name;
        axios({
          method: 'get',
          url: url,
        }).then( (response) => {
          console.log('Data', response.data)
          this.setState({
            ...this.state,
            [ship_name]: response.data
          });
        }).catch( (error) => {
                  console.log(error);
        });

  }



  getStyleOATRC(feature, layer) {
    return {
      color: '#FDFF00',
      weight: 2,
      opacity: 1
    }
  }
//#FDFF00
  getStyleSKQ(feature, layer) {
    return {
      color: '#66FF66',
      weight: 3,
      opacity: 1
    }
  }

  getStyleARK(feature, layer) {
    return {
      color: '#FD0E35',
      weight: 2,
      opacity: 1
    }

  }




  render() {

    console.log(this.state)
    let position1 = [77.499509, 1.916239];
    let position2 = [58.761750, -166.248787]
    let position3 = [72.056884, 35.661205]

    return (
      <div className = 'intro'>
        <p>
          Welcome to the cPSITRES Big Data system for sea ice analysis.
          This system provisions open-source state-of-the-art analysis on sea ice rasters captured by the Polar Sea Ice Topography REconstruction System (PSITRES) along with related publicly available data.
          We encourage users to upload their methods and models of analysis to enable rapid knowlege discovery of contemproray research.<br/>
        </p>
      <h1 style = {{marginBottom : "5px"}}> Data Catalog </h1>
      <p style = {{marginBottom : "5px"}}>
      Our public data catalog includes a variety of standard sea ice raster datasets.
      The spaital coverage of each dataset is illustrated below in the maps below and you can query and analyse these datasets directly on the web app or download then through our APIs.
      </p>
      <div className = 'data-portal'>

      <div className = "data-catalog">

      </div>
        <div className = "data-portal-dataset">
            <p style = {{  color : "#3498DB", textAlign: 'center'}}> <b>OATRC</b> </p>
            <hr></hr>
            <p>
              Data was collected by the PSITRES camera system deployed onboard the Swedish icebreaker Oden, during the OATRC research expedition. <br/>
              Raster resolution of each raster: <b><em>2448 pixel x 2048 pixels</em></b> <br/>
              Spatial coverage of each raster : <b><em>1 km. square</em></b><br/>
              Temporal Duration of dataset: <b><em>21st August 2013 - 31st August 2013</em></b><br/>
            </p>
            <hr></hr>
            <div className = "map">
            <Map className = "map" center={position1} zoom={4}>
              <TileLayer
                attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              { Object.keys(this.state.oatrc).length !== 0 ?
                <GeoJSON key = {'123'} style={this.getStyleOATRC}  data = {this.state.oatrc}/>
              :null}
            </Map>
            </div>
            <hr></hr>
            <Link id = "OATRC" to = "/geo/ice/OATRC">
                Click here to analyze OATRC dataset
            </Link>
          </div>
          <div className = "data-portal-dataset">
              <p style = {{  color : "#1ABC9C", textAlign: 'center'}}> <b>SKQ201505S</b> </p>
              <hr></hr>
              <p>
              Data was collected by the PSITRES camera system deployed onboard the R/V Sikuliaq, during the SKQ201505S research expedition. <br/>
              Raster resolution of each raster: <b><em>2448 pixel x 2048 pixels</em></b> <br/>
              Spatial coverage of each raster : <b><em>1 km. square</em></b><br/>
              Temporal Duration of dataset: <b><em>21st March 2015 - 6th April 2015</em></b><br/>
              </p>
              <hr></hr>
              <div className = "map">
              <Map className = "map" center={position2} zoom={3}>
                <TileLayer
                  attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                { Object.keys(this.state.skq).length !== 0 ?
                  <GeoJSON key = {'123'} style={this.getStyleSKQ}  data = {this.state.skq}/>
                :null}
              </Map>
              </div>
              <hr></hr>
              <Link id = "SKQ" to = "/geo/ice/SKQ2015">
                  Click here to analyze SKQ201505S dataset
              </Link>
            </div>
            <div className = "data-portal-dataset">
                <p style = {{ color : "#212F3D", textAlign: 'center'}}> <b>ARKXXVII/3</b> </p>
                <hr></hr>
                <p>
                Data was collected by the PSITRES camera system deployed onboard the POLARSTERN cruise, during the ARK-XXVII/3 research expedition. <br/>
                Raster resolution of each raster: <b><em>2448 pixel x 2048 pixels</em></b> <br/>
                Spatial coverage of each raster : <b><em>1 km. square</em></b><br/>
                Temporal Duration of dataset: <b><em>11th August 2012 - 1st October 2012</em></b><br/>
                </p>
                <hr></hr>
                <div className = "map">
                <Map className = "map" center={position3} zoom={1}>
                  <TileLayer
                    attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  />
                  { Object.keys(this.state.ark).length !== 0 ?
                    <GeoJSON key = {'123'} style={this.getStyleARK}  data = {this.state.ark}/>
                  :null}
                </Map>
                </div>
                <hr></hr>
                <Link id = "ARK" disabled = {true}>
                  Coming soon!
                </Link>
              </div>
        </div>
      </div>

    );
  }

  componentDidMount(){
    this.getSpatialCoverage('oatrc')
    this.getSpatialCoverage('skq')
    this.getSpatialCoverage('ark')

  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home/Home.js